import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  // wrapper:{
  //     displa
  // },
  formCard: {
    width: '82%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '20px auto',
    padding: '15px',
  },
  cardTitle: {
    margin: '5px 0',
    color: theme.palette.text.primary,
  },
  halfWidth: {
    width: '48%',
    marginBottom: '15px',
    '&>*': {
      width: '100%',
    },
  },
  fullWidth: {
    width: '100%',
  },
  input: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    width: '100%',
  },
  selectBox: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    '& .MuiInput-underline:before': {
      borderBottom: '0',
    },
  },
  permission: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupPermissions: {
    maxHeight: '300px',
    overflowY: 'scroll',
  },
  groupPermissionWrapper: {
    width: '100%',
    marginBottom: '20px',
  },
  groupPermissionItem: {
    width: '100%',
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
    borderRadius: '5px',
    padding: '10px 15px',
  },
  groupPermissionItemTop: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupPermissionItemTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  groupPermissionItemRemoveButton: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  checkBoxFormControl: {
    '& .MuiFormControlLabel-label': {
      color: theme.palette.text.primary,
    },
  },
  permissionSearchBox: {
    position: 'sticky',
    top: 0,
    paddingTop: '10px',
    backgroundColor: theme.palette.grey[500],
  },
  permissionContainer: {
    backgroundColor: theme.palette.grey[500],
    borderRadius: '5px',
    padding: '0px 15px 10px 15px',
    cursor: 'pointer',
  },
  permissionListContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '300px',
    overflowY: 'scroll',
  },
  searchInput: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: '5px',
    width: '100%',
    marginBottom: '10px',
    padding: '5px 7px',
  },
  fieldErrors: {
    color: theme.palette.error.main,
  },
  requiredText: {
    color: theme.palette.error.main,
    padding: '0 0 10px 20px',
  },
  confirmPassword: {},
  '@media (max-width: 1855px)': {
    confirmPassword: {
      marginTop: '20px',
    },
  },
  cancelSaveButtons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default useStyles;
